import moment from 'moment';

export function getInvoiceWeek(date = new Date()) {
  const currentDate = moment(date);

  return {
    year: currentDate.isoWeekYear(),
    week: currentDate.isoWeek()
  };
}
